import { useState, useEffect } from "react";

export const useLoadingState = (searchTerm: string, activeFilter: string) => {
  const [isLoading, setIsLoading] = useState(false);

  // Search debounce effect
  useEffect(() => {
    if (searchTerm) {
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [searchTerm]);

  // Filter change effect
  useEffect(() => {
    if (activeFilter !== "all") {
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [activeFilter]);

  return isLoading;
};
